<template>
  <v-card>
    <Subheader v-model="search" title="Stations" search="locations">
      <template v-slot:title>
        <v-toolbar-title style="width: 270px;">
          <v-icon medium>router</v-icon>
          <span class="headline">{{ title }}</span>
        </v-toolbar-title>
      </template>
      <template v-slot:actions v-if="supportsRefresh">
        <v-btn icon :loading="loading" @click="refresh">
          <v-icon>refresh</v-icon>
        </v-btn>
      </template>
    </Subheader>
    <v-data-table
      hide-headers
      :items="monitoringFeatures"
      :headers="headers"
      :search="search"
      :pagination.sync="pagination"
      item-key="DisplayName"
      class="elevation-1"
      :loading="loading"
    >
      <template v-slot:items="{ item }">
        <td class="text-xs-left">{{ getDisplayName(item) }}</td>
        <td class="text-xs-right">
          <v-btn depressed small :to="{ name: 'monitoringfeature', params: { monitoringFeatureId: item.Id } }">
            <span class="text-capitalize">View</span>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

export default {
  name: 'MonitoringFeaturesTableWidget',
  props: {
    widgetId: { type: String, required: true },
    config: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loading: false,
      error: null,
      search: null,
      headers: [
        { text: 'Station Name', align: 'left', value: 'DisplayName', sortable: true },
        { text: '', sortable: false },
      ],
      pagination: {
        sortBy: 'DisplayName',
        rowsPerPage: 10,
      },
    }
  },
  computed: {
    ...monitoringFeatures.mapGetters(['monitoringFeatures', 'getDisplayName']),
    title() {
      return this.config.title || 'Monitoring Locations'
    },
    supportsRefresh() {
      return false // This widget does not support refresh, but the toolbar is included for consistency with other widgets
    },
  },
  methods: {
    async initialize() {
      this.loading = false
      this.$store.dispatch('dashboard/setWidgetData', { widgetId: this.widgetId, data: true })
    },
    async refresh() {
      // Monitoring features are loaded during app initialization (LoadingScreen).
      // To refresh, reload the page or re-authenticate.
    },
  },
}
</script>
